const urls = {
    sellerProfile : 'authentication/seller-profile/',
    customerProfile : 'authentication/customer-profile/',
    updateSellerProfile : 'authentication/seller-profile/<>/',
    updateCustomerProfile : 'authentication/customer-profile/<>/',
    productList : 'apis/pharma-products/',
    productDetails : 'pharma-product/<>/',
    apiList : 'apis/pharma-apis/',
    fixedPrice : 'apis/fixed-price/',
    fixedPriceRetrieveUpdate : 'apis/fixed-price/<>/',
    apiDetails : 'pharma-api/<>/',
    dealList : 'auctions/deals/',
    deal : 'auctions/deal/',
    dealWrite : 'auctions/deal/<>/',
    bidCreate : 'auctions/bid-create/',
    login : 'authentication/validate/',
    googleLogin : '/authentication/social-media-login/',
    getResetPasswordLink : '/authentication/password-reset/link/',
    resetPassword : 'authentication/password-reset/',
    register : 'authentication/register/',
    countries : 'master/countries/',
    enquiry : 'enquiries/',
    enquiryResponse : 'enquiries/response/',
    enquiryList : 'enquiries/list/',
    enquiryDetails : 'enquiries/<>/',
    certificates : 'master/certificates/',
    businessSegments : 'master/business-segments/',
    createProfile : 'authentication/profile/',
    units : 'master/units/',
    pharmacopoeiaGrades : 'master/pharmacopoeia-grades/',
    license : 'master/licenses/',
    stats : 'master/stats/',
    fixedPriceList : 'apis/fixed-prices/',
    fileUpload : 'master/file-upload/',
    deleteFile : 'master/file-update/<>/',
    enquiryResponseList : 'enquiries/response-list/',
    myBids : 'auctions/my-bids/',
    allContacts : 'whatsapp/all-threads/',
    whatsappThread : 'whatsapp/threads/',
    sendWhatsAppMessage : 'whatsapp/send-message/',
    addWhatsAppContact : 'whatsapp/add-contact/',
    staffLogin : 'authentication/staff-validate/',
    blogList : 'blogs/',
    blogDetails : 'blogs/<>/',
    productListWithFixedPrice : 'apis/products-spot-buying/',
    order : 'orders/',
    userList : 'authentication/user-list/',
    downloadWhatsAppMedia : 'whatsapp/download-media/<>/'
}

export const restrictedLoggingEndPoints = [
    urls.login,
    urls.register,
    urls.resetPassword
]

export default urls;

